import React from "react";
import _pub63C09B0F from "./__DEPRECATED__typography.pc";
import _pubDa25D269 from "./__DEPRECATED__tailwind.pc";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import "./TextInput.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var Clear = React.memo(React.forwardRef(function Clear(props, ref) {
  return React.createElement("button", {
    "className": "_caa7ba36 _5ab99334 _pub-5ab99334 _pub-a97d53f3" + (props["hidden"] ? " " + "_5ab99334_hidden _pub-5ab99334_hidden _pub-a97d53f3_hidden hidden" : ""),
    "ref": ref,
    "type": "button",
    "onClick": props["onClick"],
  }, null)
}));
export { Clear };

var Eye = React.memo(React.forwardRef(function Eye(props, ref) {
  return React.createElement("button", {
    "className": "_2d1f9731 _5ab99334 _pub-5ab99334 _pub-a97d53f3" + (props["hidden"] ? " " + "_5ab99334_hidden _pub-5ab99334_hidden _pub-a97d53f3_hidden hidden" : ""),
    "ref": ref,
    "type": "button",
    "onClick": props["onClick"],
  }, null)
}));
export { Eye };

var EyeOff = React.memo(React.forwardRef(function EyeOff(props, ref) {
  return React.createElement("button", {
    "className": "_1af67a12 _5ab99334 _pub-5ab99334 _pub-a97d53f3" + (props["hidden"] ? " " + "_5ab99334_hidden _pub-5ab99334_hidden _pub-a97d53f3_hidden hidden" : ""),
    "ref": ref,
    "type": "button",
    "onClick": props["onClick"],
  }, null)
}));
export { EyeOff };

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_f4f81b3e _5ab99334 _pub-5ab99334 _pub-a97d53f3" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : ""),
    "ref": ref,
  }, 
    React.createElement(props.tagName || "input", {
      "className": "_fb8d6e43 _5ab99334 _pub-5ab99334 _pub-a97d53f3" + " " + "_5ab99334___input _pub-5ab99334___input _pub-a97d53f3___input __input " + " " + "_da25d269_appearance-none _pub-da25d269_appearance-none appearance-none" + " " + " " + (props["inputclass"] ? " " + props["inputclass"] : "") + (props["secondary"] ? " " + "_5ab99334_secondary_input _pub-5ab99334_secondary_input _pub-a97d53f3_secondary_input secondary_input _5ab99334_secondary_input-text _pub-5ab99334_secondary_input-text _pub-a97d53f3_secondary_input-text secondary_input-text" : "") + (props["v3"] ? " " + "_5ab99334_v3 _pub-5ab99334_v3 _pub-a97d53f3_v3 v3 _5ab99334_v3-text _pub-5ab99334_v3-text _pub-a97d53f3_v3-text v3-text" : "") + (props["v4"] ? " " + "_5ab99334_v3 _pub-5ab99334_v3 _pub-a97d53f3_v3 v3 _5ab99334_v3-text _pub-5ab99334_v3-text _pub-a97d53f3_v3-text v3-text _5ab99334_v4 _pub-5ab99334_v4 _pub-a97d53f3_v4 v4" : "") + (props["round"] ? " " + "_5ab99334_round _pub-5ab99334_round _pub-a97d53f3_round round" : "") + (props["value"] ? " " + "_5ab99334_has-value _pub-5ab99334_has-value _pub-a97d53f3_has-value has-value" : "") + (props["large"] ? " " + "_5ab99334___large _pub-5ab99334___large _pub-a97d53f3___large __large" : "") + (props["small"] ? " " + "_5ab99334___small _pub-5ab99334___small _pub-a97d53f3___small __small _5ab99334_small _pub-5ab99334_small _pub-a97d53f3_small small" : "") + (props["active"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active" : "") + (props["hover"] ? " " + "_5ab99334_hover _pub-5ab99334_hover _pub-a97d53f3_hover hover" : "") + (props["xsmall"] ? " " + "_5ab99334___xsmall _pub-5ab99334___xsmall _pub-a97d53f3___xsmall __xsmall" : "") + (props["darker"] ? " " + "_5ab99334_darker _pub-5ab99334_darker _pub-a97d53f3_darker darker" : "") + (props["positive"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active _5ab99334_positive _pub-5ab99334_positive _pub-a97d53f3_positive positive" : "") + (props["warning"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active _5ab99334_warning _pub-5ab99334_warning _pub-a97d53f3_warning warning" : "") + (props["success"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active _5ab99334_success _pub-5ab99334_success _pub-a97d53f3_success success" : "") + (props["fail"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active _5ab99334_fail _pub-5ab99334_fail _pub-a97d53f3_fail fail" : "") + (props["negative"] ? " " + "_5ab99334_active _pub-5ab99334_active _pub-a97d53f3_active active _5ab99334_negative _pub-5ab99334_negative _pub-a97d53f3_negative negative" : "") + (props["hasError"] ? " " + "_5ab99334___hasError _pub-5ab99334___hasError _pub-a97d53f3___hasError __hasError" : "") + (props["minimal"] ? " " + "_5ab99334___minimal _pub-5ab99334___minimal _pub-a97d53f3___minimal __minimal" : ""),
      "type": props["type"]||"text",
      "ref": props["inputRef"],
      "data-testid": props["testid"],
      "testid": props["testid"],
      "placeholder": props["placeholder"],
      "style": castStyle(props["style"]),
      "name": props["name"],
      "id": props["id"],
      "onFocus": props["onFocus"],
      "autoFocus": props["autoFocus"],
      "onBlur": props["onBlur"],
      "value": props["value"],
      "defaultValue": props["defaultValue"],
      "onChange": props["onChange"],
      "onKeyPress": props["onKeyPress"],
      "disabled": props["disabled"],
      "tabIndex": props["tabIndex"],
      "autoComplete": props["autoComplete"],
    }, null),
    props["icon"]&&React.createElement("div", {
      "className": "_30d811a6 _5ab99334 _pub-5ab99334 _pub-a97d53f3",
    }, 
      props["icon"]
    )
  )
}));
export default $$Default;

var TextInputPreview = React.memo(React.forwardRef(function TextInputPreview(props, ref) {
  return React.createElement(_pubBab5A68F_Preview, {
    "class": "_1d9bbe0b _5ab99334 _pub-5ab99334 _pub-a97d53f3",
    "ref": ref,
  }, 
    React.createElement("h4", {
      "className": "_88072267 _5ab99334 _pub-5ab99334 _pub-a97d53f3",
    }, 
      "<TextInput />"
      
    ),
    React.createElement($$Default, {
      "class": "_ff0012f1" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "placeholder patito",
      "value": "test",
    }, null),
    React.createElement($$Default, {
      "class": "_6609434b" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "placeholder patito",
      "value": "test@test.test",
    }, null),
    React.createElement($$Default, {
      "class": "_110e73dd" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "warning",
      "active": true,
    }, null),
    React.createElement($$Default, {
      "class": "_8f6ae67e" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "positive",
      "positive": true,
    }, null),
    React.createElement($$Default, {
      "class": "_f86dd6e8" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "negative",
      "negative": true,
    }, null),
    React.createElement($$Default, {
      "class": "_61648752" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "placeholder": "disabled",
      "disabled": true,
    }, null),
    React.createElement($$Default, {
      "class": "_1663b7c4" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "small": true,
      "placeholder": "primary color override",
      "hover": true,
    }, null),
    React.createElement($$Default, {
      "class": "_86dcaa55" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "small": true,
      "placeholder": "small",
    }, null),
    React.createElement($$Default, {
      "class": "_f1db9ac3" + " " + "_da25d269_my-1 _pub-da25d269_my-1 my-1",
      "tagName": "textarea",
      "value": "something",
      "small": true,
      "placeholder": "small",
    }, null)
  )
}));
export { TextInputPreview };


